import React, { Suspense } from 'react';
import waitImg from '../../images/waits.png';
import './lazyApp.css';

/**
 * Wrap a React.lazy import so it can be plugged straight into the
 * `component:` slot of `programs.js` without needing every renderer to
 * wrap the result in <Suspense>. This is what keeps the main bundle
 * lean — the dynamic `import()` becomes its own webpack chunk that is
 * only fetched when the user actually opens that program.
 *
 * The fallback renders a centred Win 3.1-style hourglass + "Loading…"
 * label so the existing WindowBorder / TitleBar layout stays put while
 * the chunk streams in, but the user can clearly see something is
 * happening.
 *
 * Usage:
 *   const Notepad = lazyApp(
 *     () => import(/* webpackChunkName: "app-notepad" *\/ '../apps/Notepad'),
 *   );
 *   { component: Notepad, ... }
 */
export function lazyApp(loader, { fallback } = {}) {
	const Lazy = React.lazy(loader);
	const Wrapped = (props) => (
		<Suspense fallback={fallback ?? <DefaultLoader />}>
			<Lazy {...props} />
		</Suspense>
	);
	Wrapped.displayName = `LazyApp(${loader.name || 'anonymous'})`;
	return Wrapped;
}

export const DefaultLoader = () => (
	<div className="wb32-lazy-loader" role="status" aria-live="polite">
		<img className="wb32-lazy-loader__hourglass" src={waitImg} alt="" />
		<div className="wb32-lazy-loader__label">Loading…</div>
	</div>
);

export default lazyApp;
